<template>
    <div class="table-records" @click="closeContextMenu">
        <!-- Her bir grup için döngü -->
        <div
            v-for="(groupItem, gIndex) in groupedData"
            :key="`group-${gIndex}-${getGroupHash(groupItem)}`"
            class="group-container"
        >
            <!-- Grup başlığı satırı -->
            <div
                class="table-row group-header-row"
                v-if="groupValue.fieldId && groupItem.key && groupItem.key !== 'N/A'"
                :style="{ backgroundColor: getGroupColor(gIndex) }"
                @click="toggleGroup(gIndex)"
            >
                <div class="table-cell group-header-cell" :colspan="visibleFields.length + 1">
                    <i class="material-icons group-icon">
                        {{ isGroupExpanded(gIndex) ? "expand_more" : "chevron_right" }}
                    </i>
                    {{ groupItem.key }}
                </div>
            </div>

            <!-- Grup içeriği -->
            <div v-show="isGroupExpanded(gIndex)" class="group-content">
                <!-- Bu grup içindeki kayıtları listeleme <!-- :key="`${record._id}-${getRecordHash(record)}`" -->
                <div
                    v-for="record in groupItem.records"
                    :key="record._id"
                    class="table-row"
                    :id="`record-${record._id}`"
                    :class="{ selected: isSelectionModeActive && isSelected(record._id) }"
                    :data-record-id="record._id"
                    @mouseover="!isSelectionModeActive && showCheckbox(record._id)"
                    @mouseleave="!isSelectionModeActive && hideCheckbox(record._id)"
                    :style="{ backgroundColor: getRecordColor(record) }"
                >
                    <div class="table-cell record-id-cell">
                        <template v-if="pickerMode">
                            <a-button type="primary" size="small" @click="$emit('record-selected', record)">
                                Select
                            </a-button>
                        </template>
                        <template v-else>
                            <div
                                v-if="!isSelectionModeActive && !isCheckboxVisible(record._id)"
                                class="record-id-cell-container"
                            >
                                <div class="left">
                                    <div v-if="!pickerMode" class="count-badges">
                                        <a-badge
                                            v-if="record.commentCount > 0"
                                            :count="record.commentCount"
                                            class="count-badge"
                                            @click="isSelectionModeActive ? $.noop : viewRecord(record, 'comments')"
                                        >
                                            <a-icon type="message" />
                                        </a-badge>
                                        <a-badge
                                            v-if="record.taskCount > 0"
                                            :count="record.taskCount"
                                            class="count-badge"
                                            @click="isSelectionModeActive ? $.noop : viewRecord(record, 'tasks')"
                                        >
                                            <a-icon type="check-circle" />
                                        </a-badge>
                                    </div>
                                </div>
                                <div class="middle">
                                    {{ record.recordId }}
                                </div>
                                <div class="right"></div>
                            </div>
                            <div v-else class="record-id-cell-container">
                                <div class="left">
                                    <div v-if="!isSelectionModeActive && !pickerMode" class="count-badges">
                                        <a-badge
                                            v-if="record.commentCount > 0"
                                            :count="record.commentCount"
                                            class="count-badge"
                                            @click="viewRecord(record, 'comments')"
                                        >
                                            <a-icon type="message" />
                                        </a-badge>
                                        <a-badge
                                            v-if="record.taskCount > 0"
                                            :count="record.taskCount"
                                            class="count-badge"
                                            @click="viewRecord(record, 'tasks')"
                                        >
                                            <a-icon type="check-circle" />
                                        </a-badge>
                                    </div>
                                </div>
                                <div class="middle">
                                    <a-checkbox
                                        class=""
                                        :checked="isSelected(record._id)"
                                        @change="$emit('toggle-selection', record._id)"
                                    ></a-checkbox>
                                </div>
                                <div class="right">
                                    <SupsisButton
                                        @click="viewRecord(record)"
                                        ghost
                                        primary
                                        v-if="!isSelectionModeActive"
                                    >
                                        <i class="material-icons">open_in_new</i>
                                        {{ $t("modules.viewRecord") }}
                                    </SupsisButton>
                                </div>
                            </div>
                        </template>
                    </div>

                    <div
                        class="table-cell table-cell-outer"
                        v-for="(field, index) in visibleFields"
                        :key="`${field._id}-${record._id}`"
                        @click="setActiveCell(record._id, field._id)"
                        :class="{ active: isActiveCell(record._id, field._id) }"
                        @keydown.tab.exact.prevent="moveToNextCell(record._id, index)"
                        @keydown.enter.exact.prevent="editCell(record._id, field._id)"
                        tabindex="0"
                        :data-field-type="field.fieldType"
                        @contextmenu.prevent="onCellContextMenu($event, field, record)"
                    >
                        <!-- Yeni Context Menü Yapısı -->
                        <div
                            v-if="
                                contextMenuVisible &&
                                contextMenuField._id === field._id &&
                                contextMenuRecord._id === record._id
                            "
                            class="context-menu-container"
                            :style="{
                                left: `${contextMenuX}px`,
                                top: `${contextMenuY}px`,
                            }"
                            @click.stop
                        >
                            <div class="context-menu">
                                <div class="context-menu-item" @click.stop="addFilter(field, record)">
                                    <i class="material-icons" style="color: #4caf50; vertical-align: middle"
                                        >add_circle</i
                                    >
                                    <span style="vertical-align: middle">Filtreye Ekle</span>
                                </div>
                                <div
                                    class="context-menu-item"
                                    :class="{ disabled: !isFilterActive(field, record) }"
                                    @click.stop="removeFilter(field, record)"
                                >
                                    <i class="material-icons" style="color: #f44336; vertical-align: middle"
                                        >remove_circle</i
                                    >
                                    <span style="vertical-align: middle">Filtreden Çıkar</span>
                                </div>
                            </div>
                        </div>

                        <LoadingCell v-if="loading" :fieldType="field.fieldType" />
                        <StringCell
                            v-else-if="['text', 'long-text', 'email', 'url', 'phone', 'ai'].includes(field.fieldType)"
                            :record="record"
                            :field="field"
                            @update-record="updateRecord($event)"
                            ref="stringCells"
                            :readonly="pickerMode"
                            :ai-mode="field.fieldType === 'ai'"
                        />
                        <CheckboxCell
                            v-else-if="field.fieldType === 'checkbox'"
                            :record="record"
                            :field="field"
                            @update-record="updateRecord($event)"
                            :readonly="pickerMode"
                        />
                        <NumberCell
                            v-else-if="field.fieldType === 'number'"
                            :record="record"
                            :field="field"
                            @update-record="updateRecord($event)"
                            :readonly="pickerMode"
                        />
                        <CurrencyCell
                            v-else-if="field.fieldType === 'currency'"
                            :record="record"
                            :field="field"
                            @update-record="updateRecord($event)"
                            :readonly="pickerMode"
                        />
                        <DropdownCell
                            v-else-if="field.fieldType === 'dropdown'"
                            :record="record"
                            :field="field"
                            @update-record="updateRecord($event)"
                            :readonly="pickerMode"
                        />
                        <DateCell
                            v-else-if="field.fieldType === 'datetime'"
                            :record="record"
                            :field="field"
                            @update-record="updateRecord($event)"
                            :readonly="pickerMode"
                        />
                        <ButtonCell
                            v-else-if="field.fieldType === 'automation-button'"
                            :record="record"
                            :field="field"
                            :tableId="table._id"
                            @update-record="updateRecord($event)"
                            :readonly="pickerMode"
                        />
                        <AssetCell
                            v-else-if="['file', 'video', 'image', 'audio'].includes(field.fieldType)"
                            :record="record"
                            :field="field"
                            @update-record="updateRecord($event)"
                            :readonly="pickerMode"
                        />
                        <UserCell
                            v-else-if="field.fieldType === 'user'"
                            :record="record"
                            :field="field"
                            @update-record="updateRecord($event)"
                            :readonly="pickerMode"
                        />
                        <ContactCell
                            v-else-if="field.fieldType === 'contact'"
                            :record="record"
                            :field="field"
                            @update-record="updateRecord($event)"
                            :readonly="pickerMode"
                        />
                        <ConversationCell
                            v-else-if="field.fieldType === 'conversation'"
                            :record="record"
                            :field="field"
                            @update-record="updateRecord($event)"
                            :readonly="pickerMode"
                        />
                        <LinkedRecordCell
                            v-else-if="field.fieldType === 'linked-record'"
                            :record="record"
                            :field="field"
                            @update-record="updateRecord($event)"
                            :readonly="pickerMode"
                        />
                        <TaskCell
                            v-else-if="field.fieldType === 'task'"
                            :record="record"
                            :field="field"
                            @update-record="updateRecord($event)"
                            :readonly="pickerMode"
                        />
                        <JsonCell
                            v-else-if="field.fieldType === 'json'"
                            :record="record"
                            :field="field"
                            @update-record="updateRecord($event)"
                            :readonly="pickerMode"
                        />

                        <div v-else class="table-cell-inner">
                            {{ getFieldValue(record, field._id) }}
                        </div>
                    </div>
                </div>

                <!-- Yeni Eklenen Summary Bileşeni (Her grubun altında) -->
                <TableFooterSummary
                    :key="`summary-${getGroupHash(groupItem)}`"
                    :records="groupItem.records"
                    :visibleFields="visibleFields"
                />
            </div>
        </div>
    </div>
</template>

<script>
import Vue from "vue";
import moment from "moment";
import StringCell from "./cells/StringCell.vue";
import CheckboxCell from "./cells/CheckboxCell.vue";
import NumberCell from "./cells/NumberCell.vue";
import CurrencyCell from "./cells/CurrencyCell.vue";
import DropdownCell from "./cells/DropdownCell.vue";
import DateCell from "./cells/DateCell.vue";
import ButtonCell from "./cells/ButtonCell.vue";
import AssetCell from "./cells/AssetCell.vue";
import UserCell from "./cells/UserCell.vue";
import ContactCell from "./cells/ContactCell.vue";
import LinkedRecordCell from "./cells/LinkedRecordCell.vue";
import LoadingCell from "./cells/LoadingCell.vue";
import SupsisButton from "../../Settings/components/SupsisButton.vue";
import { TABLE_API } from "../../../../api/table";
import { mapActions, mapState } from "vuex";
import TableFooterSummary from "./components/TableFooterSummary.vue";
import TaskCell from "./cells/TaskCell.vue";
import JsonCell from "./cells/JsonCell.vue";
import StringUtils from "../../../../utils/StringUtils";
import ConversationCell from "./cells/ConversationCell.vue";

export default Vue.extend({
    name: "TableRecords",
    props: {
        table: {
            type: Object,
            required: true,
        },
        records: {
            type: Array,
            required: true,
        },
        isSelectionModeActive: Boolean,
        selectedRecords: Array,
        visibleFields: {
            type: Array,
            required: true,
        },
        pickerMode: {
            type: Boolean,
            default: false,
        },
        groupValue: {
            type: Object,
            default: function () {
                return {
                    fieldId: null,
                    direction: "asc",
                    showEmptyGroups: false,
                };
            },
        },
        getRecordColor: {
            type: Function,
            required: true,
        },
        loading: {
            type: Boolean,
            default: false,
        },
        filters: {
            type: Array,
        },
    },
    components: {
        StringCell,
        CheckboxCell,
        NumberCell,
        CurrencyCell,
        DropdownCell,
        DateCell,
        ButtonCell,
        AssetCell,
        UserCell,
        ContactCell,
        LinkedRecordCell,
        SupsisButton,
        TableFooterSummary,
        TaskCell,
        LoadingCell,
        JsonCell,
        ConversationCell,
    },
    data() {
        return {
            activeCell: null,
            checkboxVisibility: {},
            expandedGroups: {},
            groupColors: [
                "rgb(232, 231, 228, 0.5)",
                "rgb(210, 216, 243, 0.5)",
                "rgb(222, 243, 233, 0.5)",
                "rgb(255, 244, 188, 0.5)",
                "rgb(250, 223, 217, 0.5)",
                "rgb(250, 217, 239, 0.5)",
                "rgb(235, 217, 250, 0.5)",
                "rgb(255, 243, 230, 0.5)",
            ],
            contextMenuVisible: false,
            contextMenuX: 0,
            contextMenuY: 0,
            contextMenuField: null,
            contextMenuRecord: null,
        };
    },
    computed: {
        ...mapState({
            tables: (state) => state.table.tables,
        }),
        groupedData: function () {
            if (!this.groupValue.fieldId) {
                return [{ key: null, records: this.records }];
            }

            var fieldId = this.groupValue.fieldId;
            var showEmpty = this.groupValue.showEmptyGroups;
            var groupMap = {};
            var isDescending = this.groupValue.direction === "desc";

            // İlgili alanın fieldType'ını bulalım:
            var targetField = this.visibleFields.find(function (f) {
                return f._id === fieldId;
            });

            for (var i = 0; i < this.records.length; i++) {
                var rec = this.records[i];
                var val = rec.data[fieldId];

                // Eğer val yoksa (veya 0 değilse) "N/A" olarak gösterelim
                if (!val && val !== 0 && !showEmpty) {
                    val = "N/A";
                }
                if (!val && val !== 0) {
                    val = "N/A";
                }

                if (targetField && targetField.fieldType === "datetime" && val !== "N/A") {
                    // Tarih alanları için semantik grup ismini alıyoruz
                    val = this.getSemanticDateGroup(val);
                }

                if (!groupMap[val]) {
                    groupMap[val] = [];
                }
                groupMap[val].push(rec);
            }

            var groupArray = [];
            for (var key in groupMap) {
                if (groupMap.hasOwnProperty(key)) {
                    groupArray.push({
                        key: key,
                        records: groupMap[key],
                    });
                }
            }

            // Sıralama
            groupArray.sort(function (a, b) {
                if (isDescending) {
                    if (a.key < b.key) return 1;
                    if (a.key > b.key) return -1;
                } else {
                    if (a.key < b.key) return -1;
                    if (a.key > b.key) return 1;
                }
                return 0;
            });

            return groupArray;
        },
    },
    methods: {
        ...mapActions({
            addNewWindow: "app/addNewWindow",
        }),

        /**
         * Tarihsel değerleri semantik gruba ayırır:
         * - Yesterday, Today, Tomorrow, This Week
         * - Diğerleri: "MMMM YYYY" formatında (Örneğin, "Ekim 2023")
         */
        getSemanticDateGroup: function (dateValue) {
            var d = moment(dateValue);
            var now = moment();
            console.log("getSemanticDateGroup", {
                dateValue,
                date1: d.format("YYYY-MM-DD"),
                date2: now.format("YYYY-MM-DD"),
                isToday: d.isSame(now, "day"),
                isYesterday: d.isSame(now.clone().subtract(1, "day"), "day"),
                isTomorrow: d.isSame(now.clone().add(1, "day"), "day"),
                isThisWeek: d.isSame(now, "week"),
            });

            if (d.isSame(now, "day")) {
                return "Today";
            } else if (d.isSame(now.clone().subtract(1, "day"), "day")) {
                return "Yesterday";
            } else if (d.isSame(now.clone().add(1, "day"), "day")) {
                return "Tomorrow";
            } else if (d.isSame(now, "week")) {
                return "This Week";
            }
            return d.format("MMMM YYYY");
        },

        getFieldValue(record, fieldId) {
            return record.data[fieldId] || "";
        },
        setActiveCell(recordId, fieldId) {
            this.activeCell = recordId + "-" + fieldId;
        },
        isActiveCell(recordId, fieldId) {
            return this.activeCell === `${recordId}-${fieldId}`;
        },
        viewRecord(record, defaultOpenTab = null) {
            const identifierField = this.table.fields.find((field) => field.isIdentifierField);
            let title = `${this.table.name} - ${this.$t("modules.recordViewer")} (${record.recordId})`;
            if (identifierField) {
                const isLinkedRecord = identifierField.fieldType === "linked-record";
                if (isLinkedRecord) {
                    const remoteTable = this.tables.find((t) => t._id === identifierField.options.linkedRecord.table);
                    const labelField = identifierField.options.linkedRecord.labelField;
                    const remoteField = remoteTable.fields.find((f) => f._id === labelField);
                    const isContactField = remoteField.fieldType === "contact";
                    const recordData = record.data[identifierField._id];
                    console.log("viewRecord identifierField", {
                        remoteTable,
                        labelField,
                        remoteField,
                        isContactField,
                        recordData,
                    });
                    if (isContactField) {
                        const contact = _.get(recordData, `data.${labelField}`, undefined);
                        title = contact ? contact.fullname : "İsimsiz Kişi";
                    } else if (remoteField.fieldType === "user") {
                        const user = _.get(recordData, `data.${labelField}`, undefined);
                        title = user ? user.name : "İsimsiz Kullanıcı";
                    } else {
                        title = _.get(recordData, `data.${labelField}`, "Bağlı Kayıt");
                    }
                    title = `${this.table.name} - ${title}`;
                } else {
                    const identifierValue = record.data[identifierField._id];
                    title = `${this.table.name} - ${identifierValue}`;
                }
            }
            this.addNewWindow({
                id: record._id,
                type: "table-record-viewer",
                title,
                payload: {
                    tableId: this.table._id,
                    recordId: record._id,
                    defaultOpenTab,
                },
                multiple: true,
                autoClose: false,
            });
        },
        async updateRecord({ recordId, fieldId, value }) {
            const updatingFields = {
                [fieldId]: value,
            };
            console.log("updatingFields", {
                recordId,
                fieldId,
                value,
                updatingFields,
            });
            TABLE_API.updateRecord(this.table._id, recordId, updatingFields)
                .then((record) => {
                    this.$emit("record-updated", record);
                    this.$message.success(this.$t("tables.recordUpdatedSucs"));
                })
                .catch(() => {
                    this.$message.error(this.$t("tables.failedToUpdateRecord"));
                });
        },
        moveToNextCell(recordId, currentIndex) {
            const nextIndex = (currentIndex + 1) % this.table.fields.length;
            const nextField = this.table.fields[nextIndex];

            if (nextIndex === 0) {
                const currentRecordIndex = this.records.findIndex((record) => record._id === recordId);
                const nextRecord = this.records[currentRecordIndex + 1];
                if (nextRecord) {
                    this.setActiveCell(nextRecord._id, nextField._id);
                }
            } else {
                this.setActiveCell(recordId, nextField._id);
            }
        },
        editCell(recordId, fieldId) {
            const cellKey = `${recordId}-${fieldId}`;
            const stringCell = this.$refs.stringCells.find((cell) => cell.cellKey === cellKey);
            console.log("editCell stringCells", this.$refs.stringCells);
            if (stringCell && !stringCell.editing) {
                stringCell.startEditing();
            }
        },
        showCheckbox(recordId) {
            if (!this.checkboxVisibility[recordId]) {
                console.log("showCheckbox", recordId);
                this.$set(this.checkboxVisibility, recordId, true);
            }
        },
        hideCheckbox(recordId) {
            if (this.checkboxVisibility[recordId]) {
                console.log("hideCheckbox", recordId);
                this.$set(this.checkboxVisibility, recordId, false);
            }
        },
        isCheckboxVisible(recordId) {
            return this.isSelectionModeActive || this.checkboxVisibility[recordId];
        },
        isSelected(recordId) {
            return this.selectedRecords.includes(recordId);
        },
        getGroupColor(index) {
            return this.groupColors[index % this.groupColors.length];
        },
        toggleGroup(groupIndex) {
            this.$set(this.expandedGroups, groupIndex, !this.expandedGroups[groupIndex]);
        },
        isGroupExpanded(groupIndex) {
            return this.expandedGroups[groupIndex] !== false;
        },
        getGroupHash(groupItem) {
            return StringUtils.hashCodeObj({
                key: groupItem.key,
                records: groupItem.records.map((r) => ({
                    _id: r._id,
                    data: r.data,
                })),
            });
        },
        getRecordHash(record) {
            const fields = this.table.fields
                .filter((f) => this.visibleFields.some((vf) => vf._id === f._id))
                .filter((x) => x.valueType !== "objectId")
                .map((x) => x._id);
            const hashData = _.omit(record.data, fields);

            return StringUtils.hashCodeObj({
                _id: record._id,
                updatedAt: record.updatedAt,
                createdAt: record.createdAt,
                data: hashData,
            });
        },
        onCellContextMenu(event, field, record) {
            if (!this.isFilterableField(field)) return;

            this.contextMenuVisible = true;
            this.contextMenuX = event.clientX;
            this.contextMenuY = event.clientY;
            this.contextMenuField = field;
            this.contextMenuRecord = record;
        },
        addFilter(field, record) {
            const isUserFilter = field.fieldType === "user";
            const newFilter = {
                fieldId: field._id,
                operator: "equal", // Varsayılan operatör
                value: record.data[field._id],
            };
            if (isUserFilter) {
                newFilter.value = typeof newFilter.value === "object" ? newFilter.value._id : newFilter.value;
            }
            this.$emit("update-filters", [...this.filters, newFilter]);
            this.contextMenuVisible = false;
        },
        removeFilter(field, record) {
            this.$emit(
                "update-filters",
                this.filters.filter((f) => f.fieldId !== field._id || f.value !== record.data[field._id])
            );
            this.contextMenuVisible = false;
        },
        isFilterableField(field) {
            return !["long-text", "json"].includes(field.fieldType);
        },
        isFilterActive(field, record) {
            return this.filters.some((f) => f.fieldId === field._id && f.value === record.data[field._id]);
        },
        closeContextMenu() {
            this.contextMenuVisible = false;
        },
    },
    mounted() {
        document.addEventListener("click", this.closeContextMenu);
    },
    beforeDestroy() {
        document.removeEventListener("click", this.closeContextMenu);
    },
});
</script>

<style lang="scss">
.table-records {
    width: max-content;

    .group-container {
        margin-bottom: 1px;
    }

    .group-header-row {
        cursor: pointer;
        transition: background-color 0.2s ease;

        &:hover {
            filter: brightness(0.95);
        }

        .group-header-cell {
            font-weight: bold;
            display: flex;
            align-items: center;
            padding: 8px 15px;

            .group-icon {
                margin-right: 8px;
                transition: transform 0.2s ease;
            }
        }
    }

    .group-content {
        transition: all 0.3s ease;
    }

    .table-row {
        display: flex;
        border-bottom: 1px solid #ccc;

        .table-cell {
            min-width: 245px;
            max-width: 245px;
            padding: 2px 15px;
            min-height: 40px;
            max-height: 100px;
            height: auto;
            display: flex;
            align-items: center;

            border-right: 1px solid #ccc;
            position: relative;

            &:last-child {
                //border-right: none;
            }

            &.active {
                border: 2px solid #007bff;
            }

            &.selected {
                background-color: #e6f7ff;
            }

            &[data-field-type="automation-button"] {
                width: 100%;
            }
        }

        &:hover {
            background-color: #f5f5f5;
        }

        &.selected {
            background-color: #e6f7ff;
        }
    }
}

.record-id-cell {
    justify-content: center;
    min-width: 100px;
    position: relative;
    .record-id-cell-container {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        position: relative;
        width: 100%;
        .left {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: flex-start;
            .count-badges {
                display: flex;
                gap: 4px;

                .count-badge {
                    cursor: pointer;
                    background: rgba(0, 0, 0, 0.1);
                    padding: 2px 4px;
                    border-radius: 4px;
                    transition: background 0.2s;

                    &:hover {
                        background: rgba(0, 0, 0, 0.2);
                    }

                    .ant-badge-count {
                        background: #1890ff;
                    }
                }
            }
        }
        .middle {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
        }
        .right {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: flex-end;
        }
    }

    .ant-btn {
        padding: 0 8px;
    }
}

.checkbox-container {
    display: flex;
    align-items: center;

    .ant-btn {
        margin-left: 8px;
    }
}

.context-menu-container {
    position: fixed;
    z-index: 1000;
    background: white;
    border: 1px solid #ddd;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    border-radius: 4px;

    .context-menu {
        display: flex;
        flex-direction: column;
        background-color: white;
        border: 1px solid #ccc;
        border-radius: 4px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
        padding: 8px 0;

        .context-menu-item {
            display: flex;
            align-items: center;
            padding: 8px 16px;
            cursor: pointer;
            transition: background-color 0.2s ease;

            &:hover {
                background-color: #f5f5f5;
            }

            &.disabled {
                color: #ccc;
                cursor: not-allowed;

                i {
                    color: #ccc;
                }
            }

            i {
                margin-right: 8px;
            }
        }
    }
}
</style>
